// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-tab-active":"lKnRp","redeem-form-navigation":"INTF9","redeem-form-fields":"V-tWj","redeem-form-footer-button":"v9PbH"};